<div class="question-sorting-widget">
  <lib-question-hint
    class="animate__animated"
    [ngClass]="animation()"
    [style.animationDelay.ms]="animationDelay()"
    [hint]="'CHAPTERS.drag_each_item_into_correct_folder' | translate">
  </lib-question-hint>

  <div class="question-sorting-widget__container" cdkDropListGroup [ngClass]="orienation()">

    <div class="sorting-widget-buckets">
      <div class="sorting-widget-buckets__grid">
        @for (bucket of bucketsState(); track bucket.id; let i = $index) {
          <div 
            class="animate__animated sorting-bucket" 
            cdkDropList 
            [ngClass]="animation()"
            [style.animationDelay.ms]="animationDelay() + i * 200"
            [cdkDropListData]="{ index: i }" 
            (cdkDropListDropped)="drop($event)"
            (click)="dropSelectedItemToBucket(i)">
            <ng-template cdkDragPlaceholder></ng-template>
            <div class="sorting-bucket__header">
              <lib-question-answer-option-code class="option-code" [index]="i" [numeric]="true"></lib-question-answer-option-code>
              {{ bucket.text }}
            </div>

            <div class="sorting-bucket__body">
              @for (card of bucket.droppedItems; track card.id; let i = $index) {
                <lib-question-option
                  cdkDrag
                  [cdkDragData]="card"
                  cdkDragPreviewClass="sorting-option-drag-preview"
                  theme="square"
                  class="sorting-item-option"
                  [class.selected-item]="card.id === selectedItem()?.id"
                  [style.zIndex]="bucket.droppedItems?.length - i"
                  [index]="card.index"
                  [text]="card.text"
                  [mediaType]="card.mediaType"
                  [mediaImage]="card.mediaImage"
                  (click)="setSelectedItem(card, $event)">
                </lib-question-option>
              }
            </div>
          </div>
        }
      </div>
    </div>

    @if (!isMobileViewport()) {
      <ng-container [ngTemplateOutlet]="itemsTray"></ng-container>
    }

    <ng-template #itemsOverlayTemplate>
      <div class="sorting-items-overlay" [class.d-none]="itemsLeft()?.length === 0">
        <ng-container [ngTemplateOutlet]="itemsTray"></ng-container>
      </div>
    </ng-template>

    <ng-template #itemsTray>
      <div class="sorting-items-container" [class.collapsed]="isItemsOverlayCollapsed()" [class.d-none]="readonlyMode() && itemsLeft()?.length === 0">
        <div class="sorting-items-container__header" (click)="toggleItemsOverlayCollapsed()">
          {{ 'SLIDES.missing_cards' | translate }}

          <lib-icon class="caret-icon" icon="caret-down"></lib-icon>
        </div>

        <div class="sorting-items-container__body">
          <ng-scrollbar class="overlay-items-scroll" orientation="vertical">
            <div class="sorting-widget-items" [class.d-none]="readonlyMode() && itemsLeft()?.length === 0" (click)="dropSelectedItemToBucket()">
              <div
                class="sorting-widget-items__grid"
                cdkDropList
                cdkDropListSortingDisabled
                (cdkDropListDropped)="drop($event)"
                [cdkDropListData]="{ index: -1 }">
                @if (itemsLeft()?.length === 0) {
                  <div class="options-empty">
                    <lib-icon icon="check-circle" class="options-empty-icon"></lib-icon>
                  </div>
                }

                @for (card of itemsLeft(); track card.id; let i = $index) {
                  <lib-question-option
                    cdkDrag
                    (cdkDragStarted)="updateOverlayCollapsedState(true)"
                    (cdkDragEnded)="updateOverlayCollapsedState(false)"
                    [cdkDragDisabled]="readonlyMode()"
                    [cdkDragData]="card"
                    [ngClass]="animation()"
                    [style.animationDelay.ms]="animationDelay() + i * 200"
                    cdkDragPreviewClass="sorting-option-drag-preview"
                    theme="square"
                    class="animate__animated sorting-item-option"
                    [class.selected-item]="card.id === selectedItem()?.id"
                    [index]="card.index"
                    [text]="card.text"
                    [mediaType]="card.mediaType"
                    [mediaImage]="card.mediaImage"
                    (click)="setSelectedItem(card, $event)">
                    <ng-template cdkDragPlaceholder></ng-template>
                  </lib-question-option>
                }
              </div>
            </div>
          </ng-scrollbar>
        </div>
      </div>
    </ng-template>

  </div>
</div>
